import Grid from '@mui/material/Grid';
import { lastDateOfMonth } from '@bloomays-lib/utils.shared';

import { LoaderSkeleton, TitlePart, DatePicker, DatePickerValue } from '@bloomays-lib/ui.shared';
import MainCard from '../atoms/MainCard';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
  ChartData,
  ChartOptions,
} from 'chart.js';

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend);

export type OverviewChartProps = {
  isLoading: boolean;
  beginValue: Date;
  setBeginValue: (date: Date) => void;
  endValue: Date;
  setEndValue: (date: Date) => void;
  chartData: {
    data: ChartData<'line', number[], unknown>;
    options?: ChartOptions<'line'>;
  };
};

const OverviewChart = ({
  isLoading,
  beginValue,
  setBeginValue,
  endValue,
  setEndValue,
  chartData,
}: OverviewChartProps) => {
  return isLoading ? (
    <LoaderSkeleton label="" height={500} width={800} />
  ) : (
    <MainCard>
      <Grid container spacing={3}>
        <Grid size={{ sm: 12, md: 12, lg: 4 }}>
          <TitlePart textTitle="Vue d'ensemble" />
        </Grid>
        <Grid size={{ sm: 12, md: 12, lg: 4 }}>
          <DatePicker
            label="Date de début"
            value={lastDateOfMonth(new Date(beginValue), 1)}
            handleChange={(date: DatePickerValue) => {
              if (date) {
                setBeginValue(lastDateOfMonth(new Date(date), -1));
              }
            }}
          />
        </Grid>
        <Grid size={{ sm: 12, md: 12, lg: 4 }}>
          <DatePicker
            label="Date de fin"
            value={lastDateOfMonth(new Date(endValue))}
            handleChange={(date: DatePickerValue) => {
              if (date) {
                setEndValue(lastDateOfMonth(new Date(date)));
              }
            }}
          />
        </Grid>
        <Grid size={12}>
          <Line data={chartData.data} options={chartData.options} />
        </Grid>
      </Grid>
    </MainCard>
  );
};

export default OverviewChart;
export { OverviewChart };
